class LocalStoragePolyfill {
  constructor() {
    this.length = 0;

    let data = this._readCookie('localStorage');
    this.data = data ? data : {};
  }

  clear() {
    this.data = {};
    this.length = 0;
    this._clearData();
  }

  getItem(key) {
    return this.data[key] === undefined ? null : this.data[key];
  }

  key(i) {
    let ctr = 0;
    for (let k in this.data) {
      if (ctr == i) return k;
      else ctr++;
    }
    return null;
  }

  removeItem(key) {
    if (this.data[key] === undefined) this.length--;
    delete this.data[key];
    this._setData();
  }

  setItem(key, value) {
    if (this.data[key] === undefined) this.length++;
    this.data[key] = value + ''; // forces the value to a string
    this._setData();
  }

  _readCookie(name) {
    return this._getCookie(name);
  }

  _setData() {
    this._setCookie('localStorage', this.data, 365);
  }

  _clearData() {
    this._setCookie('localStorage', '', 365);
  }

  _getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return JSON.parse(c.substring(name.length, c.length));
      }
    }
    return "";
  }

  _setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    document.cookie = `${cname}=${JSON.stringify(cvalue)};expires=${d.toUTCString()};path=/`;
  }
}

export let localStoragePolyfill = new LocalStoragePolyfill();



// WEBPACK FOOTER //
// ./source/client/data-providers/localstorage-polyfill.js